module.exports = __webpack_public_path__ + "img/바바리안.147955e4.png";